import React from "react";
import { storyblokEditable } from "@storyblok/react";
import { NavDropdoenItemModel } from "../Models/NavDropdoenItemModel";
import { useNavigate } from "react-router-dom";

import "./NavDropdownItem.css";
import Utils from "../Utils/Utils";
interface NavDropdoenItemProps {
  blok: NavDropdoenItemModel;
  onClick?: () => void;
}

const NavDropdownItem: React.FC<NavDropdoenItemProps> = ({ blok, onClick }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (blok.link?.cached_url) {
      navigate(`/${blok.link.cached_url}`);
      if (onClick) {
        onClick();
      }
    }
  };

  return (
    <div className="col-3" {...storyblokEditable(blok)} onClick={handleClick}>
      {blok.image.filename && (
        <img
          src={Utils.getCacheUrl(blok.image.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image.filename)}
        />
      )}

      <div className="nav-dropdown-content">
        <div className="row">
          <h2 className="nav-dropdown-title">{blok.text}</h2>
          <p className="nav-dropdown-price">{blok.price}</p>
        </div>
        <p className="nav-dropdown-description">{blok.subText}</p>
      </div>
      {blok.flag && blok.flag.length > 0 && blok.flag[0].text && (
        <div
          className="nav-flag"
          style={{
            backgroundColor: blok.flag[0].flagColor,
            color: blok.flag[0].textColor,
          }}
        >
          {blok.flag[0].text}
        </div>
      )}
    </div>
  );
};

export default NavDropdownItem;
